// Staff (and reps, for their own clients) see a client's home page exactly as the client does — their
// catalogue, prices, best sellers, restock list, offers and amounts owed. Nothing can be clicked.
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import ClientHome from './ClientHome.jsx';
import { fetchClientHomePreview } from '../api/me.js';
import { useAuthStore } from '../stores/authStore.js';
import { can, CAP } from '../lib/access.js';

export default function ClientHomePreview() {
  const { companyId } = useParams();
  const user = useAuthStore((s) => s.user);
  const [who, setWho] = useState(null);
  useEffect(() => {
    fetchClientHomePreview(companyId)
      .then((h) => setWho({ company: h.company, contact: h.previewContact, hasLogin: h.hasLogin }))
      .catch(() => setWho({ error: true }));
  }, [companyId]);
  return (
    <>
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-info/30 bg-info-light px-4 py-3 text-sm">
        <span className="text-text-primary">
          <strong>Preview:</strong> {who?.company || 'This client'}’s home page, exactly as {who?.contact || 'their buyers'} see{who?.contact ? 's' : ''} it.
          <span className="text-text-secondary"> Buttons are disabled. Their order in progress lives in their own browser, so it isn’t shown.</span>
          {who && !who.hasLogin && !who.error && <span className="ml-1 font-medium text-warning">No one at this client has a login yet.</span>}
        </span>
        <span className="flex gap-2">
          {user?.role === 'INTERNAL_STAFF' && can(user, CAP.MANAGE_MARKETING) && (
            <Link to="/settings?tab=client-home" className="rounded-md border border-line bg-surface px-3 py-1.5 text-sm font-medium text-text-secondary hover:bg-surface-raised">
              Change sections
            </Link>
          )}
          {user?.role === 'INTERNAL_STAFF' && (
            <Link to={`/clients/${companyId}`} className="rounded-md border border-line bg-surface px-3 py-1.5 text-sm font-medium text-text-secondary hover:bg-surface-raised">
              ← Back to client
            </Link>
          )}
        </span>
      </div>
      {who?.error ? <p className="text-sm text-error">You can’t preview this client.</p> : <ClientHome preview={{ companyId }} />}
    </>
  );
}
